import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=75ef02b5&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/ep-web/components/IntSlides.vue').default,ProductsCard: require('/var/www/ep-web/components/ProductsCard.vue').default,ModalProducts: require('/var/www/ep-web/components/ModalProducts.vue').default})
